import { render, staticRenderFns } from "./appointMeeting.vue?vue&type=template&id=54b1e78a&scoped=true"
import script from "./appointMeeting.vue?vue&type=script&lang=js"
export * from "./appointMeeting.vue?vue&type=script&lang=js"
import style0 from "./appointMeeting.vue?vue&type=style&index=0&id=54b1e78a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1e78a",
  null
  
)

export default component.exports